// extracted by mini-css-extract-plugin
module.exports = {"chart":"style_chart__2FJeT","chart__number":"style_chart__number__25rU7"};